module.exports = __webpack_public_path__ + "static/map-863915b369eecba844d091b134db01a7.png";